import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  LinearProgress,
  Card as CardUI,
  CardHeader,
  CardContent,
  Grid,
  Box,
  List,
  ListItem,
} from '@material-ui/core';
import { isArray } from 'lodash';
import PropTypes from 'prop-types';
import qs from 'querystring';

import { t, number } from '~/helpers';
import api from '~/services/api';

import * as S from './styles';

export default function DialogMensagem({ open, onClose, title }) {
  const redux = useSelector((state) => state.operacaoabastecimentoexterno);

  const [estatistica, setEstatistica] = useState({});
  const [periodo, setPeriodo] = useState('');

  useEffect(async () => {
    try {
      setPeriodo(
        `${redux.params.valuewherefield[0]} até ${redux.params.valuewherefield[1]}`
      );
      const response = await api.get(
        '/amaggisabastecimentosexternos/estatistica',
        {
          params: {
            datahoraini: redux.params.valuewherefield[0],
            datahorafim: redux.params.valuewherefield[1],
          },
          paramsSerializer: (value) => qs.stringify(value),
        }
      );
      setEstatistica(response.data);
    } catch (errors) {
      if (isArray(errors)) errors.map((error) => toast.error(t(error)));
      else toast.error(t(errors));
    }
  }, [open]);

  return (
    <Dialog
      fullWidth
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      onClose={onClose}
    >
      {redux.loading && <LinearProgress />}

      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>

      <p style={{ paddingLeft: '25px', paddingBottom: '10px' }}>{periodo}</p>

      <DialogContent>
        <S.Wrapper>
          <Grid container spacing={0}>
            <Grid item xs={6}>
              <CardUI>
                <CardHeader
                  style={{ paddingBottom: '0px' }}
                  title="Importação Original"
                />
                <CardContent>
                  <Box display="flex">
                    <Box>
                      <List dense>
                        <ListItem divider>
                          <S.ListItemField
                            primary="Número de registros importados"
                            secondary={estatistica.total}
                          />
                        </ListItem>
                        <ListItem divider>
                          <S.ListItemField
                            primary="Processados"
                            secondary={estatistica.total_processados_original}
                          />
                          <S.ListItemField
                            primary="%"
                            secondary={number(
                              estatistica.percentual_contingencia_original,
                              2
                            )}
                          />
                        </ListItem>
                        <ListItem divider>
                          <S.ListItemField
                            primary="Contingência"
                            secondary={estatistica.total_contingencia_original}
                          />
                        </ListItem>
                      </List>
                    </Box>
                  </Box>
                </CardContent>
              </CardUI>
            </Grid>
            <Grid item xs={6}>
              <CardUI>
                <CardHeader
                  style={{ paddingBottom: '0px' }}
                  title="Estado Atual"
                />
                <CardContent>
                  <Box display="flex">
                    <Box>
                      <List dense>
                        <ListItem divider>
                          <S.ListItemField
                            primary="Número de registros importados"
                            secondary={estatistica.total}
                          />
                        </ListItem>
                        <ListItem divider>
                          <S.ListItemField
                            primary="Processados"
                            secondary={estatistica.total_processados}
                          />
                          <S.ListItemField
                            primary="%"
                            secondary={number(
                              estatistica.pencentual_contingencia,
                              2
                            )}
                          />
                        </ListItem>
                        <ListItem divider>
                          <S.ListItemField
                            primary="Contingência"
                            secondary={estatistica.total_contingencia}
                          />
                        </ListItem>
                      </List>
                    </Box>
                  </Box>
                </CardContent>
              </CardUI>
            </Grid>
          </Grid>
        </S.Wrapper>
      </DialogContent>

      <DialogActions>
        <Button color="primary" variant="outlined" onClick={onClose}>
          Voltar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DialogMensagem.propTypes = {
  title: PropTypes.string.isRequired,
};
